module.exports = __webpack_public_path__ + "static/media/A R I Z O N A - Still Alive [Official Audio].fa7ec66a.mp3";